module.exports = __webpack_public_path__ + "img/57-l.2fe539ab.png";